import { CryptoService } from './../core/crypto.service';
import { Injectable } from '@angular/core';
import { ApiService } from '../core/api.service';
import { PlatformLocation } from '@angular/common'
import { Subject } from 'rxjs';
import { Mappings } from '../../shared/mapping';
import { Http, Headers, RequestOptionsArgs} from '@angular/http';

declare var CustomersCanvas: any;

@Injectable()
export class CustomersCanvasService {
    constructor
        (
            public _api: ApiService,
            private location: PlatformLocation,
            private mappings: Mappings,
            private http: Http,
            private cryptoService: CryptoService
        ) {
    }

    // Observable string sources
    private isCanvasModalOpenedSource = new Subject<boolean>();
    private isCanvasProductDesignApprovedSource = new Subject<boolean>();
    // Observable string streams
    isCanvasModalOpened$ = this.isCanvasModalOpenedSource.asObservable();
    isCanvasProductDesignApproved$ = this.isCanvasProductDesignApprovedSource.asObservable();

    public toShowCanvasContainer = false;

    //Object containing data generated by getProofImages.
    approveData = null;
    //Object containing data generated by finishProductDesign.
    renderData = null;
    //Object containing data generated by saveProduct.
    saveData = null;
    editor = null;
    loadData = null;
    currentPage = "design";
    workflowPages = {};
    documentLinks: string[] = [""];

    // Service canvas state / if it is opened or closed 
    setCanvasState(isOpened: boolean) {
        this.isCanvasModalOpenedSource.next(isOpened);
    }

    // Service canvas state / if product design is approved or not
    setCanvasProductDesignState(isApproved: boolean) {
        this.isCanvasProductDesignApprovedSource.next(isApproved);
    }

    //load a script and after it is loaded, instantiate an canvas iframe
    public openCanvasEditor(canvasInfo: any, isStateId: boolean) {
        const canvasUrl = this.cryptoService.decryptString(canvasInfo.CanvasUrl);

        if (canvasUrl != "") {
            const canvasScript = document.querySelector('script[src=\"' + canvasUrl + '\"]');
            // set canvas state as opened, so inside of components we know when to stick and when unstick some divs
            this.setCanvasState(true);

            // if script is already loaded, don't append it again
            if (canvasScript == null) {
                let node = document.createElement('script');
                node.src = canvasUrl;
                node.setAttribute("id", "CcIframeApiScript");
                node.type = 'text/javascript';
                node.async = true;
                node.charset = 'utf-8';

                // to display canvas container
                this.toShowCanvasContainer = true;

                // after script is loaded, instantiate canvas iframe
                node.onload = () => {
                    this.instanciateIframe(canvasInfo, isStateId);
                };

                document.getElementsByTagName('head')[0].appendChild(node);
            }
            else {
                this.instanciateIframe(canvasInfo, isStateId);
            }
        }
    }

    public instanciateIframe(canvasInfo: any, isStateId: boolean) {
        const templateImagesFolderPath = canvasInfo.TemplateImagesFolderPath;
        const canvasUserUsername = canvasInfo.CustomerCanvasUserName;
        const watermark = canvasInfo.Watermark;
        
        // defining product folder path
        let productDefinition;
        if (isStateId) {
            // getting design by state id
            productDefinition = canvasInfo.CanvasStateId;
        }
        else {
            productDefinition = { surfaces: templateImagesFolderPath }
        }

        // const productDefinition = { surfaces: { designFolder: productFolderPath } };
        const editorFrame = document.getElementById("editorFrame");

        const configuration = {
            userId: canvasUserUsername,
            initialMode: "Advanced",
            watermark: {
                text: {
                    text: watermark,
                    opacity: 0.3
                }
            },
            widgets:
            {
                // To disable a download button when the project is in the production
                FinishButton: { mode: "Disabled" },
                GalleryDialog: {
                    defaultTabName: "User",
                    tabs: [
                        {
                            name: "User",
                            type: "user",
                            translationKey: "GalleryDialog.TAB_USER",
                            canEdit: true,
                            canUpload: true
                        },
                        {
                            name: "Public",
                            type: "public",
                            subFolderName: "",
                            translationKey: "GalleryDialog.TAB_PUBLIC",
                            canEdit: false
                        }
                    ]
                }
            }
        };

        CustomersCanvas.IframeApi.loadEditor(editorFrame, productDefinition, configuration)
            .then(e => {
                this.editor = e;
            }
            )
            //If there was an error thrown when loading the editor.
            .catch(error => {
                if (error != null) {
                    this.loadData = this.handleError(error, "Load failed with exception: ");
                }
            });
    }

    saveCanvasProduct() {
        this.editor.saveProduct()
            //If the product has been successfully saved.
            .then(result => {
                //Saving the product state info.
                this.saveData = result;
            })
            //If there was an error thrown when saving the product.
            .catch(error => {
                this.saveData = this.handleError(error, "Save failed with exception: ");
            });
    }

    getImagesLinks(editorPage, approvePage, finishOrderPage) {
        this.workflowPages = {
            "design": { elements: editorPage },
            "approve": { elements: approvePage },
            "finish": { elements: finishOrderPage }
        }
        this.documentLinks = [];

        if (this.editor) {
            this.editor.getProofImages()
                //If proof images have been successfully received.
                .then(result => {
                    //Saving proof images info.
                    this.approveData = result;
                    // add all links to images to the documentLinks, because we will use that list for element manipulation later
                    if (this.approveData.proofImageUrls) {
                        this.approveData.proofImageUrls.forEach(element => {
                            if (element.length > 0) {
                                this.documentLinks.push(element[0]);
                            }
                        });
                    }

                    //Go to the approval page.
                    this.setupPage("approve");
                    this.setBackgroundImagesUrl();
                })
                //If there was an error thrown while getting the proof images.
                .catch(error => {
                    this.approveData = this.handleError(error, "Getting proof images failed with exception: ");
                });
        }
    }

    //img tags inside of slider are later changed to be divs with background image url property, so we need to manage that
    setBackgroundImagesUrl() {
        let sliderImageElements = $(".tp-bgimg.defaultimg");

        // because we can't use *ngFor to create as many elements as we need, we need to remove one li element if there is actually only one element we get from customer canvas(we have 2 elements in html)
        if (sliderImageElements.length > this.documentLinks.length) {
            let differenceItems = sliderImageElements.length - this.documentLinks.length;
            for (let index = 1; index <= differenceItems; index++) {
                const element = sliderImageElements[sliderImageElements.length - index];
                //remove li parent of element we found
                const parentLi = $(element).parents("li");
                $(parentLi)[0].remove();
            }
        }

        //because we can't use angular binding with slider plugin (plugin is initialized before service), we need to set url and src attributes of each slide
        if (this.documentLinks && this.documentLinks.length > 0) {
            sliderImageElements = $(".tp-bgimg.defaultimg");

            for (let index = 0; index < this.documentLinks.length; index++) {
                const link = this.documentLinks[index];
                const foundDomElement = $(sliderImageElements)[index];

                if (foundDomElement) {
                    $(foundDomElement).css('background-image', 'url(' + link + ')');
                    $(foundDomElement).attr("src", link);
                }
            }
        }
    }

    finishProductCustomization() {
        return this.editor.finishProductDesign()
    }

    setupPageAfterProductCustomization(renderData: any, isError: boolean) {
        if (!isError) {
            this.renderData = renderData;
        }
        else {
            this.renderData = this.handleError(renderData, "Product customization completion failed with exception: ");
        }
    }

    openDocumentInNewTab() {
        let sliderElements = $("#approvePage ul li");

        if (sliderElements.length > 0) {
            for (let index = 0; index < sliderElements.length; index++) {
                const element = sliderElements[index];
                //if element has this class, it means it is active inside of slider, so we want to open that element in a new tab
                if ($(element).hasClass("active-revslide")) {
                    window.open(this.documentLinks[index], "_blank");
                }
            }
        }
    }

    openNewProductInEditor() {
        if (this.editor != null) {
            this.editor.revertProduct();
            this.setupPage("design");
        }
    }

    reopenProductInEditor() {
        this.setupPage("design");
    }

    // set details of view we want to show and set layout properties depending on view
    setupPage(page) {
        const destPageData = this.workflowPages[page];

        if (this.workflowPages[this.currentPage]) {
            const elements = this.workflowPages[this.currentPage].elements;
            if (elements && elements.nativeElement && elements.nativeElement.id) {
                // getting id of element that needs to be hidden
                const generatedIdHide = `#${elements.nativeElement.id}`;
                $(generatedIdHide).fadeOut(() => {
                    if (destPageData && destPageData.elements && destPageData.elements.nativeElement && destPageData.elements.nativeElement.id) {
                        // getting id of element that needs to be shown
                        const generatedIdShow = `#${destPageData.elements.nativeElement.id}`
                        $(generatedIdShow).show();

                        this.currentPage = page;
                    }
                });
            }
        }
    }

    handleError(error, message) {
        console.error(message, error);
        return error;
    };


    updatePrevCanvasInfo(canvasData: any) {
        let url = this.mappings.Web_Api_Update_Prev_Canvas_Info;

        const params = {
            RowIdPrev: canvasData.RowIdPrev,
            CanvasStateId: canvasData.stateId,
            CanvasHiResOutputUrls: canvasData.hiResOutputUrls
        }

        return this._api.post(url, params);
    }

    // removing state from customers canvas
    deleteCustomerCanvasState(canvasInfo) {
        // const apiKey = '01b3ecc6-6423-4684-b469-f258afa87100';
        const decryptedApiKey = this.cryptoService.decryptString(canvasInfo.CanvasApiKey);
        const baseUrl = this.mappings.Canvas_Web_Api_Base_Url.replace('{apiKey}', decryptedApiKey);
        
        let url = baseUrl + this.mappings.Web_Api_Delete_Customers_Canvas_State;
        url = url.replace('{userId}', canvasInfo.CustomerCanvasUserName).replace('{stateId}', canvasInfo.CanvasStateId);
        const apiKeyFinal = `ApiKey_${decryptedApiKey}`;

        // configure headers for creating a valid request
        let options: RequestOptionsArgs = {};
        options.headers = new Headers();

        options.headers.append('X-CustomersCanvasAPIKey', apiKeyFinal);
        options.headers.append('Content-Type', 'application/json');

        return this.http.delete(url, options);
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/inventory/customerscanvas.service.ts